import app from 'flarum/forum/app';

export default {
  view() {
    const translationPrefix = 'yingtao-forum-homepage.forum.latest';

    return (
      <header className="YingtaoLatestHeading">
        <h2>{app.translator.trans(`${translationPrefix}.title`)}</h2>
        <p>{app.translator.trans(`${translationPrefix}.description`)}</p>
      </header>
    );
  },
};
